import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CModalDisplayDocumentsComponent } from 'src/app/components/c-modal/c-modal-display-documents/c-modal-display-documents.component';
import { CumulateListsLengthsModule } from 'src/app/pipes/cumulate-lists-lengths/cumulate-lists-lengths.module';
import { DocumentsLevagesEditablesModule } from 'src/app/pipes/documents-levages-editables/documents-levages-editables.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [CModalDisplayDocumentsComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,

    // pipes
    DocumentsLevagesEditablesModule,
    CumulateListsLengthsModule,
  ],
  exports: [CModalDisplayDocumentsComponent],
})
export class CModalDisplayDocumentsModule { }
